'use strict';

function SalaryRoundController(salaryService, $location, $q, $modal, $window) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.showRound = showRound;
  vm.showRoundModal = showRoundModal;
  vm.showDeleteModal = showDeleteModal;
  vm.deleteRound = deleteRound;
  vm.createRound = createRound;
  vm.formChanged = formChanged;
  vm._requestAll = _requestAll;
  vm._refreshRounds = _refreshRounds;

  vm.indexToRemove = 0;
  vm.dataToRemove = {};

  function $onInit(response) {
    $window.location = 'manager/performance-assessment/round-management/';
    return;
    vm._refreshRounds(response);
  }

  function _requestAll() {
    salaryService.list
      .round()
      .then(vm._refreshRounds);
  }

  function _refreshRounds(response) {
    vm.rounds = (response || vm).data.rounds;

    var deleteableRound = {
      canBeDeleted: true
    };

    var roundsWithInvites = vm.rounds
      .map(function (round) {
        return salaryService.list
          .invite(round.id)
          .then(function (invites) {

            if (invites.data.invites.length === 0 && invites.data.invited.length === 0) {
              var roundThatCanBeDeleted = angular.copy(round);
              return angular.extend(roundThatCanBeDeleted, round, deleteableRound);
            }
            return round;
          });
      });

    $q.all(roundsWithInvites).then(function (rounds) {
      vm.rounds = rounds;
    });

    return response;
  }

  function showRound(_, round) {
    return $location.path(salaryService.urls.invite.base({round: round.id}));
  }

  function showRoundModal(index, data) {
    var modal = $modal({template: require('./salary-round.edit.modal.html'), show: true});

    modal.$scope.data = data;
    modal.$scope.data.questionnaires = vm.data.questionnaires;
    modal.$scope.data.assessment_rounds = vm.data.assessment_rounds;

    modal.$scope.submit = function editRound(questionnaire, description, goals, performanceReviewRound) {
      return salaryService.update.round(data.id, questionnaire.id, description, performanceReviewRound ? performanceReviewRound.id : null)
        .then(salaryService.list.round)
        .then($onInit)
        .then(modal.hide);
    };

    modal.$scope.change = function (questionnaire, description) {
      if (data.description === description) {
        return $q.resolve();
      }

      return formChanged(questionnaire, description);
    };

    modal.$scope.reset = function () {
      modal.hide();
      return $q.resolve;
    };
  }

  function showDeleteModal(index, data) {
    vm.deleteModal = $modal({
      template: require('./salary-round.delete.modal.html'),
      show: true
    });
    vm.indexToRemove = index;
    vm.dataToRemove = data;
    vm.deleteModal.$scope.submit = deleteRound;
  }

  function deleteRound() {
    salaryService.delete
      .round(vm.dataToRemove.id)
      .then(vm._requestAll)
      .finally(vm.deleteModal.$scope.$hide());
  }

  function formChanged(questionnaire, description) {
    return vm.rounds.some(function (round) {
      return round.description === description;
    }) ? $q.reject()
      : $q.resolve();
  }

  function createRound(questionnaire, description, goals, performanceReviewRound) {
    return salaryService.create
      .round(questionnaire.id, description, performanceReviewRound ? performanceReviewRound.id : null)
      .then(salaryService.list.round)
      .then($onInit);
  }
}

module.exports = SalaryRoundController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-round/salary-round.controller.js
 ** module id = 226
 ** module chunks = 0
 **/